// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YK35","question":"styles_question__2reQT","inputVisibleButton":"styles_inputVisibleButton__3pye0","note":"styles_note__Mp1HV"};